import { render, staticRenderFns } from "./NoteTakingServices.vue?vue&type=template&id=e9de7d0e&scoped=true&"
import script from "./NoteTakingServices.vue?vue&type=script&lang=js&"
export * from "./NoteTakingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9de7d0e",
  null
  
)

export default component.exports